/*
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-10-10 11:28:17
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2025-10-13 11:40:23
 * @FilePath: /designcenter/src/api/modules/placedevices.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getApiRequest } from '@/utils'
import type { IRes } from '@/types'

const request = getApiRequest()

export interface CategoryMenuParams {
  templateTypeId: number | string
}

/** 旧版设计中心仍在传递 templateId，保留类型兼容但不用于重构版调用。 */
export interface LegacyCategoryMenuParams extends CategoryMenuParams {
  templateId?: number | string
}

// 查询产品分类菜单
export async function categoryMenu(params: CategoryMenuParams | LegacyCategoryMenuParams) {
  return request.get<IRes<unknown>>('/design/category/menu', { params })
}

export interface Filter {
  optionId?: number
  valueIdList?: number[] | string[]
}

/**
 * CategoryProductDTO
 */
export interface CategoryProductDTO {
  categoryId: number
  current?: number
  filters?: Filter[]
  size?: number
  search?: string
  templateTypeId?: number
}

// 产品分类 产品列表
export async function categoryProduct(data: CategoryProductDTO) {
  return request.post<IRes<unknown>>('/design/category/product', data)
}

//搜索产品
export async function productSearch(data: CategoryProductDTO) {
  return request.post<IRes<unknown>>('/design/product/search', data)
}

export interface ComponentListDTO {
  projectId?: number
  type?: number
  name?: string
}

//查询组件列表
export async function componentList(data: ComponentListDTO) {
  return request.post<IRes<unknown>>('/design/component-list', data)
}

export async function fileUploadAdd(data: FormData) {
  return request.post<IRes<unknown>>('/design/file-upload/add', data)
}

export async function componentUpload(data: FormData, params?: Record<string, string>) {
  return request.post<IRes<unknown>>(`/design/component/upload`, data, { params })
}

// 删除组件校验
export async function componentRemoveCheck(params: { id: number }) {
  return request.get<IRes<number>>('/design/component/removeCheck', { params })
}

// 删除组件

export interface IcomponentRemoveRequest {
  /**
   * id集合
   */
  ids: number[]
}

export async function componentRemove(data: IcomponentRemoveRequest) {
  return request.post<IRes<number>>('/design/component/remove', data)
}
